import React, {Component} from "react";
import PropTypes from 'prop-types';

import {getLang} from "./../../cc-imports";


class CCLang extends Component {

    static propTypes = {

        key : PropTypes.string
    }

    static defaultProps={
        width:50,
        height : 50,
        key : 'en'
    }

    render() {
        return (
            <div className="flex-container" >
                <img style={{height:60,width:60,marginLeft:15}}src={getLang(this.props.code)}/>
            </div>
        );
    }
}


export default CCLang;


// WEBPACK FOOTER //
// ./src/app/components/CCLang/CCLang.js